import React, { useState } from "react";
import { FaFileUpload } from "react-icons/fa";

import { useToasts } from "react-toast-notifications";
import { Box, BoxHeading } from "../../../../../components/Box";
import { Textarea } from "../../../../../components/Form/Textarea";
import Modal from "../../../../../components/ModalLib";
import { Button } from "../../../../../components/ui/button";
import {
  RegisterSeller,
  RegisterSellerFile,
} from "../../../../../hook/queries/useRegisterSeller";
import api from "../../../../../service/api";
import { ButtunSubmit } from "../../../styles";
import { ContainerFiles } from "../ContainerFiles";
import { ModalUploadFile } from "../ModalUploadFile";

interface Props {
  onReload: () => void;
  isValidDocument: boolean;
  data: RegisterSeller;
}

interface ModalUploadFileProps {
  name: string;
  key: string;
}

const LIST_FILES = [
  { name: "Comprovante de endereço", key: "addressProof" },
  { name: "Cartão CNPJ", key: "cnpjCard" },
  {
    name: "Contrato Social ou Requerimento Empresarial",
    key: "corporateContract",
  },
  { name: "Nota fiscal de outra empresa", key: "invoiceFromOtherCompany" },
  { name: "Comprovante de dados bancários", key: "partnersDocument" },
  { name: "Descrição de optante do Simples", key: "bankDataProof" },
  { name: "Documentos do CORE", key: "simpleOptionDescription" },
  { name: "Documento dos sócios", key: "coreDocuments" },
];

export function TabListFiles({ onReload, isValidDocument, data }: Props) {
  const { addToast } = useToasts();
  const [modalUploadFile, setModalUploadFile] =
    useState<ModalUploadFileProps | null>(null);

  const [isModalResendDocumentsOpen, setIsModalResendDocumentsOpen] =
    useState(false);
  const [obs, setObs] = useState("");

  function handleCloseModal() {
    setModalUploadFile(null);
    onReload();
  }

  async function handleResendDocuments() {
    let hasFilesInvalid = true;

    for (const listFile of LIST_FILES) {
      const files = data[
        listFile.key as keyof RegisterSeller
      ] as RegisterSellerFile[];

      for (const file of files) {
        if (file.validDocument === false) {
          hasFilesInvalid = false;
        }
      }
    }

    if (hasFilesInvalid) {
      return addToast(
        "Não é possível realizar o reenvio dos documentos porque todos estão validos",
        {
          appearance: "warning",
          autoDismiss: true,
        }
      );
    }

    await api.put(`/register-seller/${data?.id}`, {
      statusCod: 9,
      statusObs: obs,
    });

    setIsModalResendDocumentsOpen(false);
    onReload();

    return addToast("Documentos reenviados", {
      appearance: "success",
      autoDismiss: true,
    });
  }

  return (
    <Box>
      {LIST_FILES.map((file) => (
        <div key={file.key}>
          <div
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <BoxHeading style={{ marginBottom: 0 }}>{file.name}</BoxHeading>

            {isValidDocument && (
              <Button
                variant="secondary"
                style={{ width: 30, height: 30 }}
                onClick={() =>
                  setModalUploadFile({ name: file.name, key: file.key })
                }
              >
                <FaFileUpload size="0.8rem" />
              </Button>
            )}
          </div>

          <ContainerFiles
            registerSellerData={data}
            isValidDocument={isValidDocument}
            // @ts-ignore
            files={data[file.key]}
            fileKey={file.key}
          />
        </div>
      ))}

      {[8].includes(data.status.cod) && (
        <ButtunSubmit
          style={{ marginBottom: 0 }}
          onClick={() => setIsModalResendDocumentsOpen(true)}
        >
          Solicitar reenvio dos documentos
        </ButtunSubmit>
      )}

      <Modal
        modalVisible={!!isModalResendDocumentsOpen}
        setModalVisible={setIsModalResendDocumentsOpen}
        height={250}
        title={`Solicitar reenvio dos documentos`}
        scrollOff
      >
        <div
          style={{
            padding: 12,
          }}
        >
          <Textarea
            name="observation"
            label="Motivo de recusa dos documentos"
            onChange={(e) => setObs(e.target.value)}
            value={obs}
          />

          <ButtunSubmit
            style={{ marginBottom: 0 }}
            onClick={handleResendDocuments}
          >
            Reenvio dos documentos
          </ButtunSubmit>
        </div>
      </Modal>

      <Modal
        modalVisible={!!modalUploadFile}
        setModalVisible={() => setModalUploadFile(null)}
        height={300}
        title={`Upload de arquivo (${modalUploadFile?.name})`}
      >
        {modalUploadFile && (
          <ModalUploadFile
            fileUpload={modalUploadFile}
            registerSellerId={data.id}
            onClose={handleCloseModal}
          />
        )}
      </Modal>
    </Box>
  );
}
